import _ from "lodash";
import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import Select from "react-select";
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api, constants, helpers } from "../utils";

export default function ItemClassMaintenance(props) {
   const [firstItemList, setFirstItemList] = useState([]);
   const [firstSelectedItem, setFirstSelectedItem] = useState(null);
   const [gLAList, setGLAList] = useState([]);
   const [otherItemList, setOtherItemList] = useState([]);
   const [otherSelectedItem, setOtherSelectedItem] = useState(null);

   useEffect(reloadClasses, []);

   function getFirstItemsAvailable() {
      return api
         .post("Reference/GetItemClasses", {})
         .then((response) => {
            if (response) {
               return { FirstListOfItems: response?.data?.itemClasses };
            } else {
               return {};
            }
         }).then(dataResponse => {
            return api
               .fetch("Reference/GetItemClassesNotInPortal")
               .then((response2) => {
                  if (response2) {
                     // dataResponse.OtherListOfItems = _.reject(response2?.data?.itemClasses, x => 
                     //   _.some(dataResponse.FirstListOfItems, y => y.itemClass === x.itemClass));
                     dataResponse.OtherListOfItems = response2?.data?.itemClasses;
                     return dataResponse;
                  }
               });
         }).catch(api.catchHandler);
   }

   function getGLADropdown() {
      return api
         .fetch("Reference/GetGLAccountList")
         .then((response) => {
            if (response.data.success) {
               return { GLADropdownList: response.data.message };
            }
         })
         .catch(api.catchHandler);
   }

   function isFormValid(item) {
      let errorMessages = [];
      if (item.isFinishedGood === null) {
         errorMessages.push("Is Finished Good has no value");
      }
      if (item.isPurchasedMaterial === null) {
         errorMessages.push("Is Purchase Material has no value");
      }
      // if (!item.overheadAccountIndex) {
      //   errorMessages.push("You must select an overhead account");
      // }
      // if (!item.laborAccountIndex) {
      //   errorMessages.push("You must select a labor account");
      // }
      return errorMessages;
   }

   function onChangeSelect(selected, other) {
      if (other) {
         setFirstSelectedItem(null);
         setOtherSelectedItem(selected);
      } else {
         setFirstSelectedItem(selected);
         setOtherSelectedItem(null);
      }
   }

   function reloadClasses() {
      document.title = `Item Class Maintenance`;
      Promise.all([
         getFirstItemsAvailable(),
         getGLADropdown()
      ]).then((oldResults) => {
         let newResults = {};
         _.each(oldResults, (x) => Object.assign(newResults, x));
         const { FirstListOfItems, GLADropdownList, OtherListOfItems } = newResults;
         setFirstItemList(helpers.addLabelValueToItem(FirstListOfItems));
         setGLAList(helpers.addLabelValueToGLA(GLADropdownList));
         setOtherItemList(helpers.addLabelValueToItem(OtherListOfItems));
      });
   }

   const saveItemClass = (item, isDelete) => {
      const errorMessages = isFormValid(item);
      if (errorMessages.length) {
         for (let i = 0; i < errorMessages.length; i++) {
            toast.error(errorMessages[i]);
         }
         return;
      }

      if (isDelete) {
         api
            .post(`Item/DeleteItemClass/${item.id}`)
            .then((response) => {
               if (response.data.success) {
                  toast.success("Item has successfully been deleted");
                  setFirstSelectedItem(null);
                  reloadClasses();
               } else {
                  toast.error("Something Went Wrong: " + response.data.message);
               }
            })
            .catch(api.catchHandler);
      } else {
         let payload = { ...item };
         if (!payload.itemGroup) {
            payload.itemGroup = null;
         }
         if (payload.wasteFactor === undefined || payload.wasteFactor === '') {
            payload.wasteFactor = null;
         } else {
            payload.wasteFactor = parseFloat(payload.wasteFactor);
         }
         if (!payload.uom) {
            payload.uom = null;
         }
         delete payload.unitOfMeasure;
         api
            .post("Item/SaveItemClass", payload)
            .then((response) => {
               if (response.data.success) {
                  toast.success("Item has successfully been saved");
                  setOtherSelectedItem(null);
                  reloadClasses();
               } else {
                  toast.error("Something Went Wrong: " + response.data.message);
               }
            })
            .catch(api.catchHandler);
      }
   };

   const showDeleteModal = (item, isDelete) => {
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you wish to Item Class?`,
         buttons: [
            {
               label: "Yes",
               onClick: () => {
                  saveItemClass(item, isDelete);
               },
            },
            {
               label: "No",
            },
         ],
      });
   };

   return (
      <DesktopContainer screenName="Item Class Maintenance">
         <div className="filter-header mb-2">
            <Row className="justify-content-center">
               <Col xs={2} className="text-end">
                  <h5 children="Item Class:" className="text-white"></h5>
               </Col>
               <Col xs={6}>
                  <Select
                     classNamePrefix="serviceThreadSelect"
                     options={firstItemList}
                     value={firstSelectedItem || null}
                     onChange={(e) => onChangeSelect(e)}
                     isSearchable
                     isClearable
                  />
               </Col>
               <Col xs={1} />
            </Row>
            <Row className="justify-content-center mt-2">
               <Col xs={2} className="text-end">
                  <h5 children="Add Class:" className="text-white"></h5>
               </Col>
               <Col xs={6}>
                  <Select
                     classNamePrefix="serviceThreadSelect"
                     options={otherItemList}
                     value={otherSelectedItem || null}
                     onChange={(e) => onChangeSelect(e, true)}
                     isSearchable
                     isClearable
                  />
               </Col>
               <Col xs={1} />
            </Row>
         </div>
         {firstSelectedItem || otherSelectedItem ? (
            <ShowTheRest
               itemClass={firstSelectedItem ? firstSelectedItem : otherSelectedItem}
               glaAccountList={gLAList}
               saveOrDeleteFunction={saveItemClass}
               deleteFunction={showDeleteModal}
            />
         ) : null}
      </DesktopContainer>
   );
}

function ShowTheRest({
   itemClass,
   glaAccountList,
   saveOrDeleteFunction,
   deleteFunction,
}) {
   const [embeddedItem, setEmbeddedItem] = useState(itemClass);
   const LABOR_AND_OVERHEAD_ACCOUNTS = glaAccountList;
   const [refreshScreen, setRefreshScreen] = useState(false);

   const updateEmbedded = (fieldName, fieldValue) => {
      if (fieldValue === null) {
         setEmbeddedItem((prev) => {
            prev[fieldName] = !prev[fieldName];
            return prev;
         });
      } else {
         setEmbeddedItem((prev) => {
            prev[fieldName] = fieldValue;
            return prev;
         });
      }

      setRefreshScreen(!refreshScreen);
   };

   const updateEmbeddedOverheadLabor = (indexName, textDesc, selectObj) => {
      if (!indexName || !textDesc || !selectObj) return;
      setEmbeddedItem((prev) => {
         prev[indexName] = selectObj.value;
         prev[textDesc] = selectObj.label;
         return prev;
      });
      setRefreshScreen(!refreshScreen);
   };

   useEffect(() => {
      setEmbeddedItem(itemClass);
   }, [refreshScreen, itemClass]);

   return (
      <Card className="dashboard-card">
         <CardBody style={{ paddingLeft: "10vw", paddingRight: "10vw" }}>
            <Row>
               <Col>
                  <h5>Check all that apply (if any): </h5>
                  <hr></hr>
                  <Row className="mt-2">
                     <Col xs="1" />
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isFinishedGood"
                           checked={itemClass.isFinishedGood}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isFinishedGood)}
                        />
                        <Label for="isFinishedGood">Finished Good</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isPurchasedMaterial"
                           checked={itemClass.isPurchasedMaterial}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isPurchasedMaterial)}
                        />
                        <Label for="isPurchasedMaterial">Purchased Material</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isInProcess"
                           checked={itemClass.isInProcess}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isInProcess)}
                        />
                        <Label for="isInProcess">In Process</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isMachinePart"
                           checked={itemClass.isMachinePart}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isMachinePart)}
                        />
                        <Label for="isMachinePart">Machine Part</Label>
                     </Col>
                  </Row>
                  <Row className="mt-2">
                     <Col xs="1" />
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isDenier"
                           checked={itemClass.isDenier}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isDenier)}
                        />
                        <Label for="isDenier">Denier</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isCottonCount"
                           checked={itemClass.isCottonCount}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isCottonCount)}
                        />
                        <Label for="isCottonCount">Cotton Count</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isPkg"
                           checked={itemClass.isPkg}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isPkg)}
                        />
                        <Label for="isPkg">Package</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isChem"
                           checked={itemClass.isChem}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isChem)}
                        />
                        <Label for="isChem">Chemical</Label>
                     </Col>
                  </Row>
                  <Row className="mt-2">
                     <Col xs="1" />
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="specAllowed"
                           checked={itemClass.specAllowed}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.specAllowed)}
                        />
                        <Label for="specAllowed">Spec Allowed?</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="requiresBaseSpec"
                           checked={itemClass.requiresBaseSpec}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.requiresBaseSpec)}
                        />
                        <Label for="requiresBaseSpec">Requires Base Spec</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isEach"
                           checked={itemClass.isEach}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isEach)}
                        />
                        <Label for="isEach">Each Item</Label>
                     </Col>
                     <Col className="form-check form-check-inline">
                        <Input
                           type="checkbox"
                           name="isBulk"
                           checked={itemClass.isBulk}
                           onChange={(e) => updateEmbedded(e.target.name, !itemClass.isBulk)}
                        />
                        <Label for="isBulk">Bulk Item</Label>
                     </Col>
                  </Row>
               </Col>
            </Row>
            <Row className="mt-5">
               <Col>
                  <Row>
                     <h5>Applicable to Stock Status Report </h5>
                     <hr></hr>
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">Stocking Class:</span>
                     </Col>
                     <Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           name="stockingClass"
                           options={constants.STOCK_CLASS_LIST}
                           value={
                              embeddedItem.stockingClass
                                 ? constants.STOCK_CLASS_LIST[_.findIndex(constants.STOCK_CLASS_LIST, (x) => embeddedItem.stockingClass === x.value)]
                                 : null
                           }
                           onChange={(eventObj) =>
                              updateEmbedded("stockingClass", eventObj.value)
                           }
                           isSearchable
                        // isClearable
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
               </Col>
            </Row>
            <Row className="mt-5">
               <Col>
                  <h5>Applicable to BOM Header GL Accounts </h5>
                  <hr></hr>
                  <Row>
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">Overhead Account:</span>
                     </Col>
                     <Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           name="overHeadAccount"
                           options={_.filter(LABOR_AND_OVERHEAD_ACCOUNTS, (x) => x.isOverhead)}
                           value={
                              embeddedItem.overheadAccountIndex
                                 ? LABOR_AND_OVERHEAD_ACCOUNTS[
                                    _.findIndex(LABOR_AND_OVERHEAD_ACCOUNTS,
                                       (x) => embeddedItem.overheadAccountIndex === x.accountIndex && x.isOverhead
                                    )
                                 ]
                                 : null
                           }
                           onChange={(eventObj) =>
                              updateEmbeddedOverheadLabor("overheadAccountIndex", "overheadText", eventObj)
                           }
                           isSearchable
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
                  <Row className="mt-2">
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">Labor Account:</span>
                     </Col>
                     <Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           name="laborHeadAccount"
                           options={_.filter(LABOR_AND_OVERHEAD_ACCOUNTS, (x) => x.isLabor)}
                           value={
                              embeddedItem.laborAccountIndex
                                 ? LABOR_AND_OVERHEAD_ACCOUNTS[
                                    _.findIndex(LABOR_AND_OVERHEAD_ACCOUNTS,
                                       (x) => embeddedItem.laborAccountIndex === x.accountIndex && x.isLabor)
                                 ]
                                 : null
                           }
                           onChange={(eventObj) =>
                              updateEmbeddedOverheadLabor("laborAccountIndex", "laborText", eventObj)
                           }
                           isSearchable
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
               </Col>
            </Row>
            <Row className="mt-5">
               <Col>
                  <h5>Applicable to BOM Component Waste Factors </h5>
                  <hr></hr>
                  <Row>
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">BOM UOM:</span>
                     </Col>
                     <Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           name="uom"
                           options={constants.UOM_LIST}
                           value={
                              embeddedItem.uom
                                 ? constants.UOM_LIST[_.findIndex(constants.UOM_LIST, (x) => embeddedItem.uom === x.value)]
                                 : null
                           }
                           onChange={(eventObj) => updateEmbedded("uom", eventObj ? eventObj.value : null)}
                           isSearchable
                           isClearable
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
                  <Row className="mt-2">
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">BOM Waste %:</span>
                     </Col>
                     <Col>
                        <Input
                           name="wasteFactor"
                           type="text"
                           maxLength={5}
                           value={
                              !embeddedItem.wasteFactor || embeddedItem.wasteFactor === 0
                                 ? ""
                                 : embeddedItem.wasteFactor
                           }
                           onChange={(e) => updateEmbedded(e.target.name, e.target.value)}
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
                  <Row className="mt-2">
                     <Col xs="2" style={{ textAlign: "right", marginTop: "6px" }}>
                        <span className="fw-bold">BOM Item Group:</span>
                     </Col>
                     <Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           name="itemGroup"
                           options={constants.ITEM_GROUP_LIST}
                           value={
                              embeddedItem.itemGroup
                                 ? constants.ITEM_GROUP_LIST[
                                    _.findIndex(constants.ITEM_GROUP_LIST, (x) => parseInt(embeddedItem.itemGroup) === x.value)
                                 ]
                                 : null
                           }
                           onChange={(eventObj) => updateEmbedded("itemGroup", eventObj ? eventObj.value : null)}
                           isSearchable
                           isClearable
                        />
                     </Col>
                     <Col xs="4" />
                  </Row>
               </Col>
            </Row>

            <Row className="mt-5">
               <Col>
                  <Button className="shredButton" onClick={() => saveOrDeleteFunction(embeddedItem)} >
                     SAVE
                  </Button>
                  <Button className="shredButton float-end" onClick={() => deleteFunction(embeddedItem, true)} >
                     DELETE
                  </Button>
               </Col>
            </Row>
         </CardBody>
      </Card>
   );
}
